import { registerErrorInterceptor } from '../api';

class ResponseError extends Error {
  constructor(response, error) {
    const message =
      response.data?.message ||
      response.data?.messages?.[0] ||
      response.data ||
      error.message;

    super(message, { cause: error });
    this.messages = response.data?.messages || [message];
    this.status = response.status;
    this.statusText = response.statusText;
    this.response = response.data;
    this.code = error?.code;
    this.url = response.request.responseURL;
    this.method = response.config.method;
    this.correlationId = error.response?.headers?.['x-correlation-id'];
  }
}

registerErrorInterceptor(async (error) => {
  if (error.code === 'ERR_CANCELED') {
    return error;
  }
  let response = error?.response;
  if (!response?.data) {
    // eslint-disable-next-line no-console
    console.error('debug', JSON.stringify(response));
  }
  if (response?.data instanceof Blob) {
    response = { data: JSON.parse(await response.data.text()) };
  }

  return new ResponseError(response, error);
}, 'Error handler');
